import EditableElement from './EditableElement'

/*
Makes content of elements on the page editable.
*/

export function createEditableElement(el, onSubmit) {
    return new EditableElement(el, onSubmit)
}

export function createEditableElements(selector, onSubmit) {
    const elements = document.querySelectorAll(selector)
    const editableElements = []
    for (const el of elements) {
        editableElements.push(createEditableElement(el, onSubmit))
    }
    return editableElements
}

export function makeEditable(el, onSubmit) {
    if (typeof el === 'string') {
        createEditableElements(el, onSubmit)
    } else {
        createEditableElement(el, onSubmit)
    }
}
